var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.905,5.351C33.377,5.472 41.148,12.619 41.566,21.206C41.975,29.597 35.333,37.802 26.42,38.599C24.837,38.74 23.449,36.92 24.527,35.54C25.327,34.514 26.962,34.767 28.427,34.323C34.344,32.532 38.488,26.027 37.427,19.818C36.428,13.977 30.957,9.22 25.046,9.081C18.915,8.937 13.072,13.66 12.011,19.9L15.299,16.593C15.522,16.473 15.604,16.537 15.721,16.634L17.919,18.831C18.097,19.048 18.076,19.11 17.919,19.302C15.771,21.466 13.703,23.712 11.473,25.793C10.746,26.438 9.565,26.428 8.848,25.759L2.392,19.303C2.213,19.085 2.235,19.023 2.392,18.831L4.589,16.634C4.807,16.455 4.869,16.477 5.061,16.634L8.22,19.793C8.273,19.414 8.274,19.415 8.344,19.019C9.803,11.403 16.843,5.337 24.905,5.351Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.1b4ad2f5ed436ed12228b61a21cb973d.svg";
export { ForwardRef as ReactComponent };